import { memo } from 'react';
import { Skeleton } from '@aimsos/ui';

/** Match the band's collapsed cap (CT-4159): the loading state shows this many rows. */
const ROWS = 5;

/**
 * Loading placeholder for the Needs Your Attention band (CT-4159).
 *
 * Mirrors the real band's chrome — the amber `<section>`, the header with its
 * pulsing dot, and ROWS row-shaped card skeletons at the real row size — so the
 * load reads as "the band is coming" instead of a generic grey block. Purely
 * decorative, so the whole tree is `aria-hidden`.
 */
function NeedsAttentionBandSkeleton() {
  return (
    <section
      aria-hidden="true"
      className={[
        'rounded-[10px] border border-[rgba(251,191,36,0.22)] border-l-2 border-l-[#FDC700]',
        'bg-[rgba(251,191,36,0.04)] p-[18px]',
      ].join(' ')}
    >
      <header className="mb-[14px] flex items-center gap-2.5">
        <span className="h-[7px] w-[7px] animate-pulse rounded-full bg-[#FDC700]" />
        <Skeleton width={150} height={11} borderRadius={4} />
      </header>

      <ul className="flex flex-col gap-1.5">
        {Array.from({ length: ROWS }, (_, i) => (
          <li
            key={i}
            className="flex items-center justify-between gap-4 rounded-[10px] border border-edge bg-surface px-4 py-3"
          >
            <div className="flex min-w-0 items-center gap-3">
              <Skeleton width={28} height={28} borderRadius={8} />
              <div className="flex flex-col gap-1.5">
                <Skeleton width={140} height={13} borderRadius={4} />
                <Skeleton width={210} height={11} borderRadius={4} />
              </div>
            </div>

            <div className="flex shrink-0 items-center gap-2.5">
              <Skeleton width={110} height={30} borderRadius={8} />
              <Skeleton width={88} height={20} borderRadius={9999} />
              <Skeleton width={26} height={26} borderRadius={9999} />
            </div>
          </li>
        ))}
      </ul>

      {/* Placeholder for the "Show all N" toggle — the real band only renders it
          when there are >5 items, but during load the count is unknown, so we
          reserve its space to avoid a layout jump when the band arrives. */}
      <div className="mt-3">
        <Skeleton width={120} height={38} borderRadius={8} />
      </div>
    </section>
  );
}

export default memo(NeedsAttentionBandSkeleton);
